/* eslint-disable no-underscore-dangle */
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';

L.Marker.Tooltip = L[L.Layer ? 'Layer' : 'Class'].extend({
  options: {
    pane: 'markerPane',
    snapIgnore: true,
  },

  /**
   * Inicia a função
   * 
   * @param {*} latlng 
   * @param {*} content 
   * @param {*} options 
   */
  initialize: function (latlng, content, options) {
    L.setOptions(this, options);

    this._latlng = latlng;
    this._content = '<p>';
    if (Array.isArray(content)) {
      content.forEach((c) => (this._content += `${c}<br />`));
    } else {
      this._content += content;
    }
    this._content += '</p>';
  },

  addTo: function (map) {
    map.addLayer(this);
    return this;
  },

  onAdd: function (map) {
    this._map = map;
    var pane = this.getPane ? this.getPane() : map.getPanes().markerPane;
    var el = (this._element = L.DomUtil.create(
      'div',
      'leaflet-zoom-animated gba-popup-info',
      pane
    ));
    var contentWrapper = L.DomUtil.create(
      'div',
      'gba-popup-info-content-wrapper',
      el
    );
    var contentContainer = L.DomUtil.create(
      'div',
      'gba-popup-info-content',
      contentWrapper
    );
    var inner = L.DomUtil.create('p', '', contentContainer);
    inner.innerHTML = this._content;

    map.on('zoomanim', this._animateZoom, this);

    this._setPosition();
  },

  onRemove: function (map) {
    map.off('zoomanim', this._animateZoom, this);
    var pane = this.getPane ? this.getPane() : map.getPanes().markerPane;
    pane.removeChild(this._element);
    this._map = null;
  },

  _setPosition: function () {
    L.DomUtil.setPosition(
      this._element,
      this._map.latLngToLayerPoint(this._latlng)
    );
    this._element.style.transform += ' rotate(' + this._rotation + 'rad)';
  },

  _animateZoom: function (opt) {
    var pos = this._map
      ._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center)
      .round();
    L.DomUtil.setPosition(this._element, pos);
    this._element.style.transform += ' rotate(' + this._rotation + 'rad)';
  },
});

L.marker.tooltip = function (latLng, content, options) {
  return new L.Marker.Tooltip(latLng, content, options);
};
